<template>
    <div class="row">
        <div class="col-lg-12" v-if="classroom">
            <change-subject-greeting-card :url="baseAPIURL" :classroom="classroom" :subject="subject"/>
        </div>
        <div class=" col-lg-12">
            <hotline-card title="Lessons" subtitle="2"
                          :resource-url="baseAPIURL + 'classroom/' + classroom.id + '/message/' + computedSubject +'lessons/'"
            ></hotline-card>
        </div>
        <div class=" col-lg-12">
            <hotline-card title="Teacher" subtitle="3"
                          :resource-url="baseAPIURL + 'classroom/' + classroom.id + '/message/' + computedSubject +'teacher/'"
            ></hotline-card>
        </div>
        <div class=" col-lg-12">
            <hotline-card title="Other" subtitle="4"
                          :resource-url="baseAPIURL + 'classroom/' + classroom.id + '/message/' + computedSubject +'other/'"
            ></hotline-card>
        </div>
        <div class=" col-lg-12">
            <hotline-card title="Other 5" subtitle="5"
                          :resource-url="baseAPIURL + 'classroom/' + classroom.id + '/message/' + computedSubject +'other_5/'"
            ></hotline-card>
        </div>
        <div class=" col-lg-12">
            <hotline-card title="Other 6" subtitle="6"
                          :resource-url="baseAPIURL + 'classroom/' + classroom.id + '/message/' + computedSubject +'other_6/'"
            ></hotline-card>
        </div>
        <div class=" col-lg-12">
            <hotline-card title="Other 7" subtitle="7"
                          :resource-url="baseAPIURL + 'classroom/' + classroom.id + '/message/' + computedSubject +'other_7/'"
            ></hotline-card>
        </div>
    </div>
</template>
<script>
    import ChangeSubjectGreetingCard from "./ChangeSubjectGreetingCard"
    import HotlineCard from "./HotlineCard"

    export default {
        name: 'subject',
        components: {ChangeSubjectGreetingCard, HotlineCard},
        props: {
            classroom: {},
            subject: String,
        },
        computed:{
            computedSubject() {
                return this.subject === 'kodesh' ? '' : this.subject + '_';
            }
        }
    }
</script>
<style>
    .white-content .el-table table > tbody > tr > td {
        padding: 4px 2px;
    }

</style>
